import { render, staticRenderFns } from "./TriangleObject.vue?vue&type=template&id=723e3d4c&scoped=true&"
import script from "./TriangleObject.vue?vue&type=script&lang=ts&"
export * from "./TriangleObject.vue?vue&type=script&lang=ts&"
import style0 from "./TriangleObject.vue?vue&type=style&index=0&id=723e3d4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723e3d4c",
  null
  
)

export default component.exports